import React, { useState, useEffect } from 'react';
import { Badge } from 'reactstrap';
import styled from "styled-components";
import { postAPI_Favourite, gAPI_Favourite } from '../../../../../../constants/APIs';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faStar as faStarSolid
} from '@fortawesome/free-solid-svg-icons';
import { faStar, faCopy } from '@fortawesome/free-regular-svg-icons';
import ResponseReplicationPop from './ResponseReplicationPop';
import ResponseLogs from './ResponseLogs';

function ResponseInformation({ propertyId, locale, elem, favouriteResponse, reloadBotResponse, showFav, isRelicationResponse, userRole, propertyList, selectedLang, historyUpdator }) {

  //console.log(elem.query.code, ":", favouriteResponse);
  const [isReplication, setIsReplication] = useState(false);
  const [isResponseLog, setIsResponseLog] = useState(false);

  const handleChecked = (e) => {
    e.preventDefault();
    if (favouriteResponse) {
      AxiosAPI({
        method: 'delete',
        url: `${postAPI_Favourite}`,
        data: {
          groupId: getGroupID(),
          propertyId: propertyId,
          responseCode: elem.query.code
        },
      }).then(res => {
        //console.log(res.data);
        reloadBotResponse();
      })
        .catch(err => {
          console.log('err', err);
        });
    }
    else {
      AxiosAPI({
        method: 'post',
        url: `${postAPI_Favourite}`,
        data: {
          groupId: getGroupID(),
          propertyId: propertyId,
          responseCode: elem.query.code,
          category: elem.query.category,
          hintQuestion: elem.query.hintQuestion,
          detailedExplanation: elem.query.detailedExplanation,
          example: elem.response.example
        },
      }).then(res => {
        //console.log(res.data);
        reloadBotResponse();
      })
        .catch(err => {
          console.log('err', err);
        });
    }
  };
  return (
    <div>
      <div style={{ display: "flex" }}><h2>{elem.query.hintQuestion}</h2>
        {showFav === true && (<a title={favouriteResponse ? "Remove from Favourites" : "Add to Favourites"} onClick={(e) => handleChecked(e)} >
          {favouriteResponse ? <FontAwesomeIcon icon={faStarSolid} className="fa" style={{ color: 'var(--theme-color-1)' }} /> : <FontAwesomeIcon icon={faStar} className="fa" />}
        </a>)}
      </div>
      <Badge
        color=""
        style={{ Color: '#fff', backgroundColor: '#ffd54f' }}
        className="mb-1"
      >
        <span>{elem.query.category}</span>
      </Badge>
      <div>
        <p>{elem.query.detailedExplanation}</p>
      </div>
      <div className='d-flex' style={{ alignItems: "center" }}>
        {isRelicationResponse !== false && (
          <a onClick={() => setIsReplication(true)} title="Copy">
            <FontAwesomeIcon icon={faCopy} className="fa" style={{ fontSize: 'large', color: "#a8a8a8" }} />
          </a>
        )}
        <a onClick={() => setIsResponseLog(true)} title="Change Log" style={{ marginBottom: "2px" }}>
          <i className='iconsminds-24-hour' style={{ fontSize: 'large', color: "#a8a8a8", WebkitTextStrokeWidth: "medium" }} />
        </a>
      </div>
      {isReplication && (userRole === "Admin" || userRole === "User") &&
        <ResponseReplicationPop
          code={elem.query.code}
          toggle={() => setIsReplication(!isReplication)}
          visible={isReplication}
          propertyList={propertyList}
          reloadBotResponse={reloadBotResponse}
          selectedLang={selectedLang}
        ></ResponseReplicationPop>
      }
      {isResponseLog &&
        <ResponseLogs
          toggle={() => setIsResponseLog(!isResponseLog)}
          visible={isResponseLog}
          selectedLang={selectedLang}
          code={elem.query.code}
          hintQuestion={elem.query.hintQuestion}
          historyUpdator={historyUpdator}
        ></ResponseLogs>
      }
    </div>
  );
}



const mapStateToProps = ({ settings }) => {
  const { propertyId, locale, domains } = settings;
  return {
    propertyId, locale, domains
  };
};

export default injectIntl(connect(mapStateToProps, {})(ResponseInformation));
